import type React from 'react'
import { GraphQLErrors } from '@apollo/client/errors'
import { Nullable } from '../../type'
import { ComboOption } from '../Combo'
import { FormInstance, FormProps } from 'antd'

export type SearchValueType = 'boolean' | 'threeState'

export type SearchOptions<TRequest> = {
  key: string
  label: string
  render?: (options: { isActive: boolean, index: number, labelId?: string }) => React.ReactNode
  hideExactMatch?: boolean
  setValue: (params: SearchParameters, request: TRequest) => void
  defaultValue?: any
  defaultActive?: boolean
  formItemDisabled?: boolean
  valueType?: SearchValueType
}

export type SearchParameters = {
  key: string
  value: any
  isActive: boolean
  exactMatch?: boolean
}

export type SearchAndFind = {
  id: any
  parameters: SearchParameters[]
  sorts: SortItem[]
}

export type SearchTargetOption = {
  key: string
  label: string
}

export type SearchTargetConfig<TRequest = any> = {
  options: [SearchTargetOption, SearchTargetOption]
  defaultKey: string
  onApply: (targetKey: string, request: TRequest) => void
}

export type SearchContainerProps<TRequest> = {
  open: boolean
  closeMe: () => void
  onComplete: (request: Nullable<TRequest>, page?: number, mode?: SearchMode) => void
  title: string
  idLabel: string
  searchOptions: SearchOptions<TRequest>[]
  defaultId?: any
  findPage: (id: any) => Promise<{ page?: number, error?: GraphQLErrors }>
  findPageLoading: boolean
  sort?: {
    fields: SortField[]
    defaults?: SortItem[]
  }
  onChange?: (fields: FormProps['fields']) => void
  searchTarget?: SearchTargetConfig<TRequest>
}

export type SearchProps = {
  closeMe: () => void
  open: boolean
  onPageChange?: (page: number) => void
  onComplete?: (request: any) => void
}

export enum SearchMode {
  Find = 'Find',
  Search = 'Search',
}

export type SortDirectionOptions = 'asc' | 'desc'
export type SortField = Omit<ComboOption<any>, 'item'>
export type SortItem = { field: string, direction: SortDirectionOptions }

export interface SortRequest {
  field: string
  sortOrder: SortDirectionOptions
}

export type SortContextValue = {
  fields: SortField[]
  form: FormInstance<SearchAndFind>
}
